"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_TREE_NODE_PATHS_WITH_PRODUCT_COUNTS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCT_TREE_NODE_PATHS_WITH_PRODUCT_COUNTS = (0, gql_1.gql)(`
  query productTreeNodePathsWithProductCounts(
    $productTreeId: ID!,
    $catalogId: ID!,
    $filter: ProductTreeNodeFilter,
    $first: Int,
    $firstAncestors: Int,
    $sort: [ProductTreeNodeRelativeOrderBy!],
  ) {
    productTreeNodes(ancestralProductTreeId: $productTreeId, filter: $filter, first: $first) {
      edges {
        node {
          id
          title
          productPresentationsNew(catalog: $catalogId) {
            totalCount
          }
          ancestors(first: $firstAncestors, sort: $sort) {
            edges {
              node {
                ancestor {
                  title
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`);
